<template>
    <div>
        <h2 :class="[subheaderClass, 'text-center']">{{ label }}</h2>
        <Bar class="block max-w-[100%]" :data="chartData" :options="allOptions" >
        </Bar>
    </div>
</template>

<script>
import { mapState } from 'pinia'
import { useGeneralStore } from '@/utils/useGeneralStore.js'
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: "Show Bar Chart",
    components: { Bar },
    props: ['options', 'dataset', 'label', 'responsive', 'maintainAspectRatio'],
    computed: {
        ...mapState(useGeneralStore, ['subheaderClass']),
        chartData() {
            const data= {
                labels: this.dataset?.map(d => d.name.substring(0,15)),
                datasets: [
                    {
                    label: '',
                    backgroundColor: this.colorArray,
                    data: this.dataset?.map(d => d.total)
                    }
                ]
            }
            return data
        }
    },
    data() {
        return {
            allOptions: { legend: { color: 'white'} , color: 'hsl(140, 58%, 26%)' },
            colorArray: [
                'hsl(140, 58%, 26%)',
                'hsl(110, 52%, 36%)',
                'hsl(140, 44%, 38%)',
                'hsl(125, 48%, 30%)',
                'hsl(110, 38%, 48%)',
                'hsl(155, 42%, 33%)',
                'hsl(100, 44%, 36%)',
                'hsl(140, 34%, 48%)',
                'hsl(140, 54%, 20%)',
                'hsl(118, 36%, 52%)',
                'hsl(110, 58%, 30%)',
                'hsl(145, 40%, 42%)',
            ]
        }
    },
    mounted() {
        // this.allOptions = { legend: { color: 'white'} , color: 'hsl(140, 58%, 26%)' }
    }
}
</script>
